import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommanService } from '../../_services/comman.service';
import { CommonModule } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-list-view',

  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './list-view.component.html',
  styleUrl: './list-view.component.scss',
})
export class ListViewComponent {
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  currColumns: any[] = [];
  currResultData: any[] = [];
  currResultTotal: number = 0;
  currResultCountries: any[] = [];
  currResultCompanies: any[] = [];
  loading: boolean = false;
  sortField: string = '';
  sortOrder: number = 1;
  user_data: any;
  pageLimitInDatabaseLimit: number = 0;

  constructor(
    private _commanService: CommanService,
    private datasearch: DatasearchService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this._commanService.currentPrivilege.subscribe((res) => {
      this.user_data = res;
    });
    // Get current columns

    this._commanService.getColumns().subscribe((res) => {
      this.currColumns = res;
    });

    // Get result data
    this._commanService.getResultData().subscribe((res) => {
      this.loading = false;
      this.currResultData = res;
    });

    // Get result total
    this._commanService.getResultTotal().subscribe((res) => {
      this.currResultTotal = res;
    });

    // Get result countries
    this._commanService.getResultCountries().subscribe((res) => {
      this.currResultCountries = res;
    });

    // Get result companies
    this._commanService.getResultCompanies().subscribe((res) => {
      this.currResultCompanies = res;
    });
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error: API response success is false', res);
          }
        },
        (error: any) => {
          console.log('Error fetching database page limit:', error);
        }
      );
  }
  loadColumnDetails() {

    this.datasearch.getGapdColumns().subscribe(
      (res: any) => {
        res.data.results.forEach((field: any) => {
          field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
        });
        this.currColumns = res.data.results;
        this._commanService.setColumns(this.currColumns);
      },
      (error: any) => {
        console.error('Error loading column details:', error);
      }
    );
  }
  loadRecordsLazy(event: any) {
    console.log('Lazy Load Event:', event); // Log the full event object

    const pageNumber = event.first / event.rows + 1;

    // ✅ Use database limit if available, otherwise fallback to event.rows
    const limit =
      this.pageLimitInDatabaseLimit && this.pageLimitInDatabaseLimit > 0
        ? this.pageLimitInDatabaseLimit
        : event.rows;

    const sortField = event.sortField || '';
    const sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    const filters = this.buildMongoMatchFromFilters(event.filters);

    console.log('Page:', pageNumber);
    console.log('Limit (with DB limit fallback):', limit);
    console.log('Sort Field:', sortField);
    console.log('Sort Order:', sortOrder);
    console.log('Built Filters:', filters); // Log the built filter object

    this._commanService.setPageNumber(+pageNumber);
    this._commanService.setLimit(+limit);
    this._commanService.setSortField(sortField);
    this._commanService.setSortOrder(sortOrder);
    this._commanService.setFilter(filters);
    // this._messageService.add({
    //   severity: 'warn',
    //   summary: 'Limit Reached',
    //   detail: `You can only navigate up to page ${pageNumber} with limit ${limit}`,
    // });
  }

  buildMongoMatchFromFilters(filters: any): any[] {
    const match: any = {};
    console.log('Incoming Filters:', filters);

    for (const field in filters) {
      const filterObj = filters[field];

      if (!filterObj || !filterObj.value) continue;

      const { value, matchMode } = filterObj;
      console.log(`Field: ${field}, Value: ${value}, MatchMode: ${matchMode}`);

      switch (matchMode) {
        case 'startsWith':
          match[field] = {
            $regex: `^${this.escapeRegExp(value)}`,
            $options: 'i',
          };
          break;
        case 'contains':
          match[field] = {
            $regex: `${this.escapeRegExp(value)}`,
            $options: 'i',
          };
          break;
        case 'notContains':
          match[field] = {
            $not: { $regex: `${this.escapeRegExp(value)}`, $options: 'i' },
          };
          break;
        case 'endsWith':
          match[field] = {
            $regex: `${this.escapeRegExp(value)}$`,
            $options: 'i',
          };
          break;
        case 'equals':
          match[field] = value;
          break;
        case 'notEquals':
          match[field] = { $ne: value };
          break;
        default:
          console.warn(`Unhandled matchMode: ${matchMode}`);
          break;
      }
    }

    console.log('Final Mongo Match:', match);
    return [match];
  }

  escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  scrollLeft() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft -= 500) : '';
  }
  scrollRight() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft += 500) : '';
  }
  getDocumentList(rowData: any): string[] {
    let documents = rowData?.documents
      ?.split('\n')
      .map((f: any) => f.trim())
      .filter((f: any) => f);

    return documents;
  }
}
